import { FormFieldsConfig } from '../../types';

const defaultFieldsConfig: FormFieldsConfig = {
  name: {
    label: null,
    required: true,
    hidden: false,
    placeholder: 'Il tuo nome',
    ariaLabel: 'Campo per inserire il tuo nome',
  },
  phoneNumber: {
    label: null,
    required: true,
    hidden: false,
    placeholder: 'Il tuo telefono',
    ariaLabel: 'Campo per inserire il tuo telefono',
  },
  email: {
    label: null,
    required: false,
    hidden: false,
    placeholder: 'Il tuo indirizzo email',
    ariaLabel: 'Campo per inserire il tuo indirizzo e-mail',
  },
  marketing: {
    ariaLabel: 'Campo per ricevere comunicazioni e offerte da parte di Dove.it',
    text: 'Accetto di ricevere comunicazioni e offerte da parte di Dove.it',
  },
  thirdParties: {
    ariaLabel: 'Campo per ricevere comunicazioni e offerte da parte delle società partner di Dove.it',
    text: 'Accetto di ricevere comunicazioni e offerte da parte delle società partner di Dove.it',
  },
  button: {
    label: 'Richiedi informazioni',
    ariaLabel: 'Richiedi informazioni',
  },
};

export default defaultFieldsConfig;
